import Button from "@components/Button";
import CustomInput from "../CustomInput/CustomInput";
import styles from "./ForgotPassword.module.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "@hooks/useAuth";
import ResetPassword from "@components/ResetPassword/ResetPassword";
import { useSelector } from "react-redux";

const ForgotPassword = () => {
  const [showVerifyOtpUi, setShowVerifyOtpUi] = useState(false);
  const [otp, setOtp] = useState(null);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [showResetPassword, setShowResetPassword] = useState(false);

  const { isForgotPasswordLoading } = useSelector((state) => state.auth);

  const { handleForgotPassword, handleVerifyTokenPassword } = useAuth();

  const handleSendClick = () => {
    if (email.trim() === "") {
      setIsEmailValid(false);
      return;
    }
    setIsEmailValid(true);
    handleForgotPassword({ email }, setShowVerifyOtpUi);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setIsEmailValid(true);
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleSubmitOtp = () => {
    handleVerifyTokenPassword({ email, token: otp }, setShowResetPassword);
  };

  return showResetPassword ? (
    <ResetPassword token={otp} email={email} />
  ) : showVerifyOtpUi ? (
    <div className={styles.Wrapper}>
      <span>Enter a four-digit OTP you received in your email</span>
      <CustomInput name={"otp"} onChange={handleOtpChange} />
      <Button
        btnType={"primary"}
        text={"Verify Otp"}
        className={styles.SendBtn}
        onClick={handleSubmitOtp}
      />
      <Link to="/signin" className={styles.SignIn}>
        Sign in instead
      </Link>
    </div>
  ) : (
    <div className={styles.Wrapper}>
      <CustomInput
        showLabel
        type="email"
        label={"Email"}
        name={"email"}
        onChange={handleEmailChange}
        isValid={isEmailValid}
      />
      {!isEmailValid && (
        <span style={{ color: "red" }}>Email cannot be empty</span>
      )}{" "}
      <span>
        We will send you a otp in your registered email address to reset the
        password.
      </span>
      <Button
        btnType={"primary"}
        text={"Send"}
        className={styles.SendBtn}
        onClick={handleSendClick}
        isLoading={isForgotPasswordLoading}
        isDisabled={isForgotPasswordLoading}
      />
      <Link to="/signin" className={styles.SignIn}>
        Sign in instead
      </Link>
    </div>
  );
};

export default ForgotPassword;
